
    import { Component, Vue, Watch } from 'vue-property-decorator'
    @Component({
        name: 'DashHighscorelist'
    })
    export default class DashHighscorelist extends Vue {
    }
